import moduleRegistry from '@/configuration/module-registry';
import flatMapDeep from "lodash/flatMapDeep"

var moduleService = (function() {

  let _flattenModules;

  function _setFlattenModules () {
    const getMembers = (member) => {
      if(!member.children || !member.children.length){
        return member;
      }
      return [member, flatMapDeep(member.children, getMembers)];
    }

    _flattenModules = flatMapDeep(moduleRegistry.tree, getMembers);
  }

  function _getFlattenModules () {
    if (_flattenModules == undefined) { _setFlattenModules() }
    return _flattenModules;
  }

  return {
    findModuleByModuleId: function (moduleId) {
      const allModules = _getFlattenModules();
      return allModules.find((_module) => _module.id === moduleId)
    }
  }
})();

export default moduleService;
